import { BaseEvent } from '~/app/tracking/events/base-event';
import { EventAction } from '~/app/tracking/feld-m-types';

export class PageLoadEvent extends BaseEvent {
	constructor({ pageName, destination }: { pageName: string; destination: string }) {
		super({
			eventInfo: {
				eventAction: EventAction.PageLoad,
				eventName: `configurator - ${pageName} page`,
			},
			attributes: {},
			additionalObjects: {
				componentInfo: {
					componentID: 7,
				},
				attributes: {
					implementer: 1,
					version: '1.0.0',
				},
				page: {
					pageInfo: {
						pageID: `configurator - ${pageName} page`,
					},
				},
			},
			updatePageInfo: {
				page: {
					pageInfo: {
						destinationURL: destination,
					},
				},
			},
		});
	}
}
